import Vue from 'vue'
import App from './App.vue'
import './permission'
import ElementUI from 'element-ui'
import axios from 'axios'
import router from './router'
import './assets/css/variables.css'

// 设置全局默认配置
axios.defaults.baseURL = process.env.VUE_APP_BASE_URL || '/api'
axios.defaults.timeout = 15000
axios.defaults.headers.post['Content-Type'] = 'application/json'

// 挂载到 Vue 原型
Vue.prototype.$axios = axios

Vue.use(ElementUI)

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
